import AabTypography from './AabTypography';

customElements.define('aab-typography', AabTypography);
